import styled, { createGlobalStyle } from "styled-components";

// The UI library's ModalSize.LARGE renders at 1024x720, but the onboarding
// wizard Figma is 1282x810. Resize just this modal (scoped to the "wizard-modal"
// className passed when it's opened) so the design fits. The 0,4,0 specificity
// beats the library's 0,3,0 width/height rules. The library caps both at
// calc(100% - 20px), so it still shrinks responsively on smaller viewports.
export const WizardModalWidthOverride = createGlobalStyle`
  .wizard-modal.md-parent-show .md-container .md-modal,
  .wizard-modal.md-show .md-container .md-modal {
    width: 1282px;
    height: 810px;
  }
`;

// Lays out the footer Back button's leading arrow icon and label (per Figma).
export const BackLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm, 8px);
`;

export const PairScreenModalBody = styled.div<{ $flushVertical?: boolean }>`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  min-height: 0;
  /* The WizardModal Body is a block element, so flex: 1 above is inert and this
     wrapper would collapse to content height — pin it to the Body so a step laid
     out at height: 100% (e.g. Plan & Billing) is bounded. overflow-y: auto then
     lets taller steps (e.g. Payment & Shipping) scroll within the body instead
     of being clipped. */
  height: 100%;
  /* Clip horizontally (steps own their internal layout/scroll) but allow
     vertical scroll for tall steps. overflow-y: auto on its own would compute
     overflow-x to auto too and surface a horizontal scrollbar at narrow widths,
     so pin overflow-x to hidden via the two-value shorthand. */
  overflow: hidden auto;
  padding: ${({ $flushVertical }) =>
    $flushVertical ? "0 var(--spacing-xl, 24px)" : "24px"};
  width: 100%;
`;

// Centres the currency loader / error while the trialist's billing currency is
// resolved (steps 2+ can't render prices without it).
export const CurrencyGate = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-md, 12px);
  width: 100%;
  height: 100%;
`;

export const CurrencyGateError = styled.p`
  margin: 0;
  max-width: 420px;
  text-align: center;
  font-family: Lato, sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: var(--color-destructive, #d0021b);
`;
